const translations = {
  "account.header.pre-title": "My Account Profile",
  "account.header.sub-title": "Member since {date}",
  "account.logout": "Logout",

  "account.personal.information.name": "Name",
  "account.personal.information.name.edit": "Change Name",
  "account.personal.information.name.edit.mobile": "Change",
  "account.personal.information.name.not-set": "Update your Name",
  "account.personal.information.title": "Personal information",
  "account.personal.information.email": "Email",
  "account.personal.information.email.edit": "Edit email",
  "account.personal.information.email.edit.mobile": "Edit",
  "account.personal.information.password": "Password",
  "account.personal.information.password.edit": "Change password",
  "account.personal.information.password.edit.mobile": "Change",
  "account.personal.information.address": "Address",
  "account.personal.information.address.edit": "Change address",
  "account.personal.information.address.edit.mobile": "Change",
  "account.personal.information.address.not-set": "Update your address",
  "account.personal.information.phone": "Phone",
  "account.personal.information.phone.edit": "Change phone",
  "account.personal.information.phone.edit.mobile": "Change",
  "account.personal.information.phone.not-set": "Update your phone number",

  "account.cards.title": "Payment Methods",
  "account.cards.add": "Link New Card",
  "account.cards.no-card.title": "Link your credit card to support us while earning rewards.",
  "account.cards.no-card.description": "Double the impact of your dollars without lifting a finger!",
  "account.cards.set.primary": "Set as primary",
  "account.cards.delete": "Delete",

  "account.firstName.edit": "First Name",
  "account.firstName.edit-invalid": "Invalid First Name",
  "account.lastName.edit": "Last Name",
  "account.lastName.edit-invalid": "Invalid Last Name",
  "account.fullName.edit.success": "Name changed successfully",

  "account.email.edit.current": "Current email",
  "account.email.edit.new": "New email",
  "account.email.edit.confirm": "Confirm new email",
  "account.email.edit.must-match": "Emails must match",
  "account.email.edit.success": "Email changed successfully",

  "account.password.edit.current": "Current password",
  "account.password.edit.new": "New password",
  "account.password.edit.confirm": "Confirm new password",
  "account.password.edit.must-match": "Passwords must match",
  "account.password.edit.success": "Password changed successfully",

  "account.address.edit.firstname": "First Name",
  "account.address.edit.lastname": "Last Name",
  "account.address.edit.phone": "Phone",
  "account.address.edit.street": "Street address",
  "account.address.edit.city": "City",
  "account.address.edit.zip.US": "Zip code",
  "account.address.edit.zip.CA": "Postal code",
  "account.address.edit.zip.invalid.US": "Invalid zip code",
  "account.address.edit.zip.invalid.CA": "Invalid postal code",
  "account.address.edit.state.US": "State",
  "account.address.edit.state.CA": "Province",
  "account.address.edit.province": "Province / state",

  "account.address.edit.country": "Country",
  "account.address.edit.success": "Address changed successfully",
  "account.address.error.postal-code": "Postal / zip code is required",
  "account.address.error.postal-code-incorrect-country.CA": "Postal code is not matching with selected country",
  "account.address.error.postal-code-incorrect-country.US": "Zip code is not matching with selected country",

  "account.phone.edit": "Phone number",
  "account.phone.edit-invalid": "Invalid phone number",
  "account.phone.edit.success": "Phone number changed successfully",

  "account.card.ending.digits": '{cardType} *{digits}',
  "account.card.expires": "Expires in {date}",
  "account.cards.active": "Active",
  "account.cards.default": "PRIMARY CARD",
  "account.cards.paused": "Paused",
  "account.cards.deleted": "Deleted",
  "account.cards.expired": "Expired",
  "account.cards.notice": `*All purchases from the linked cards will be rounded up to the nearest dollar, but only your primary card will be charged or receive cashback at the end of each month.  A minimum monthly charge of \${min} applies`,

  "account.membership.title": "Membership Details",
  "account.membership.subscription.title": "Your plan",
  "account.membership.subscription.description": `You’re on the {price}{frequency} {name} plan {date}`,
  "account.membership.subscription.description.renew": ` renewing on {date}`,
  "account.membership.subscription.description.churned": ` ending on {date}.`,
  "account.membership.subscription.description.nosubscription": `You are not subscribed to any plan.`,
  "account.membership.subscription.next-billing": "Plan renews on {date}",
  "account.membership.subscription.next-billing.inactive": "No active subscription",
  "account.membership.subscription.price.month": `{price}/mo`,
  "account.membership.subscription.price.year": `{price}/yr`,
  "account.membership.subscription.overdue.text": "Please review your payment details to keep you account active",
  "account.membership.subscription.overdue.btn": "Review Payment",
  "account.membership.maxRoundUp.saved": "Cap monthly donations changed successfully",
  "account.membership.maxRoundUp.disabled": "Cap monthly donations changed to default value",
  "account.membership.maxRoundUp.value": "Cap monthly donations ",
  "account.membership.maxRoundUp.value.to": "to",
  "account.membership.maxRoundUp.notice": "Define your highest monthly commitment.",
  "account.membership.downgrade.notice": "Your plan will change to the ${price}{frequency} {name} plan on {date}",
  "account.membership.maxRoundUp.form.option": "Select a value",
  "account.membership.maxRoundUp.form.donation": "Type a value",
  "account.membership.maxRoundUp.default.caption": "Remove Donation Limit?",
  "account.membership.maxRoundUp.default.notice": "All your rounded-up purchases will be donated at the end of the month.",
  "account.membership.maxRoundUp.default.confirmation": "Yes, continue",
  "account.membership.maxRoundUp.donation.validation.number": "Amount must be a number",
  "account.membership.revert.downgrade": "Cancel",
  "account.membership.maxRoundUp.donation.validation.required": "Please fill donation value",
  "account.membership.cancel": "To cancel your membership, please contact",
  "account.membership.affinity.title": "Your Sport",
  "account.membership.affinity.description": `Your contribution helps {name}.`,
  "account.membership.affinity.description.all": `Your contribution helps all our sport teams.`,

  "account.billing.title": "Billing",
  "account.billing.no-billing.title": "No transactions",
  "account.billing.no-billing.description": "There are no transactions yet",
  "account.billing.credit": "Cash Back",
  "account.billing.charge": "Membership Fee",
  "account.billing.transaction": "{name} Subscription",
  "account.billing.transaction.month": "{name} - Monthly Plan",
  "account.billing.transaction.year": "{name} - Annual Plan",
};

export default translations;